import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLoading } from "../../context/LoadingContext";
import { Card, Container } from "react-bootstrap";

export default function Administrator() {
  const { setLoading } = useLoading();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <>
      <Helmet>
        <title>ผู้ดูแลระบบ</title>
        <meta name="description" content="Administrator Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0"></Card>
      </Container>
    </>
  );
}
